import axios from '../localAxios';
import { WorkspaceQuiz } from './quiz/types/WorkspaceQuiz';
import { workspaceQuizzesURL } from './workspacesURLs';

export type CopyPersonalQuizToWorkspaceError = {
  code?: string;
  httpStatus?: number;
  message: string;
};

export type CopyPersonalQuizToWorkspaceParams = {
  workspaceId: string;
  quizIds: number[];
  parentId: string;
};

export async function copyPersonalQuizToWorkspace({
  workspaceId,
  quizIds,
  parentId,
}: CopyPersonalQuizToWorkspaceParams) {
  const url = workspaceQuizzesURL({ workspaceId: workspaceId });

  const result = await axios.post<WorkspaceQuiz>(url.href, {
    quiz_ids: quizIds,
    parent_folder_id: parentId,
  });
  return result.data;
}
